<template>
  <el-select
    v-model="status"
    :disabled="disabled"
    placeholder="เลือกสถานะ"
    clearable
  >
    <el-option
      v-for="item in statusList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { Option as ElOption, Select as ElSelect } from "element-ui";
import { isSellAndRentAdminCancelEnabled } from "../featureFlags";
import {
  SellAndRentStatus,
  SellAndRentFilterOnlyStatuses,
  getSellAndRentStatusLabel,
  SELL_AND_RENT_ADMIN_CANCEL,
  SELL_AND_RENT_ADMIN_CANCEL_LABEL
} from "../SellAndRentStatus";

export default {
  components: {
    ElOption,
    ElSelect
  },
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean
    },
    hideItem: {
      type: Function,
      default: null
    },
    showCancelItem: {
      type: Boolean,
      default: false
    },
    cancelledByAdmin: {
      type: Boolean,
      default: false
    },
    forFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    status: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    statusList() {
      const adminCancelEnabled = isSellAndRentAdminCancelEnabled()
      const includeFilterOnly = this.forFilter && adminCancelEnabled

      const items = Object.keys(SellAndRentStatus)
        .filter(value => includeFilterOnly || !SellAndRentFilterOnlyStatuses.includes(value))
        .map(value => ({
          value,
          label: getSellAndRentStatusLabel(value, this.cancelledByAdmin)
        }))
        .filter(item => !this.hideItem || !this.hideItem(item.value))

      if (this.showCancelItem && adminCancelEnabled) {
        items.push({
          value: SELL_AND_RENT_ADMIN_CANCEL,
          label: SELL_AND_RENT_ADMIN_CANCEL_LABEL
        })
      }

      return items
    }
  }
};
</script>
